<script>
    import moment from 'moment';
    import ImgUser from '@/assets/img/user.svg';
    import ImgMail from '@/assets/img/mail.svg';
    import ImgPhone from '@/assets/img/phone.svg';
    import ImgCalendar from '@/assets/img/calendar.svg';
    import ImgTime from '@/assets/img/time.svg';
    import ImgDoc from '@/assets/img/doc.svg';

    export default {
        name: 'CardProspect',
        props: ['user'],
        data() {
            return {
                imgUser: ImgUser,
                imgMail: ImgMail,
                imgPhone: ImgPhone,
                imgCalendar: ImgCalendar,
                imgTime: ImgTime,
                imgDoc: ImgDoc
            }
        },
        methods: {
            signatureStatus(value) {
                const statusMap = { false: 'A faire', ready: 'A signer', completed: 'Signé' };
                return statusMap[value] || 'A faire';
            },
            signatureClass(value) {
                const classMap = { false: 'dashboard-badge--red', ready: 'dashboard-badge--orange', completed: 'dashboard-badge--green' };
                return classMap[value] || 'dashboard-badge--red';
            },
            formatDuration (days) {
                if (days < 1) return "aujourd'hui"
                if (days === 1) return '1 jour'
                if (days < 31) return days + ' jours'
                const months = Math.floor(days / 30)
                if (months === 1) return '1 mois'
                if (months < 12) return months + ' mois'
                const years = Math.floor(months / 12)
                if (years === 1) return '1 an'
                return years + ' ans'
            }
        },
        computed: {
            statusPaysage() {
                if(this.user.pp_status) {
                    return 'A signer';
                } else if (this.user.has_pp) {
                    return 'En cours';
                } else {
                    return 'A faire';
                }
            },

            statusPaysageClass() {
                return this.user.has_pp ? 'dashboard-badge--orange' : 'dashboard-badge--red';
            },

            daysSinceCreation() {
                if (!this.user.created_at) return 0;
                const createdDate = moment(this.user.created_at, 'DD/MM/YYYY HH:mm');
                const days = moment().diff(createdDate, 'days')
                return this.formatDuration(days)
            },

            // Date exacte de création (traçabilité RGPD)
            creationDate() {
                if (!this.user.created_at) return null;
                return moment(this.user.created_at, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY');
            },

            lettreMissionStatus() {
                return this.signatureStatus(this.user.lettre_de_mission_signe);
            },

            lettreMissionClass() {
                return this.signatureClass(this.user.lettre_de_mission_signe);
            },

            rapportMissionStatus() {
                return this.signatureStatus(this.user.rapport_mission_signe);
            },

            rapportMissionClass() {
                return this.signatureClass(this.user.rapport_mission_signe);
            }
        }
    }
</script>

<template lang="html">
	<article class="card-prospect dashboard-card dashboard-card--bordered dashboard-card--hoverable">
            <header class="dashboard-card__header">
                <img class="dashboard-card__icon" :src="imgUser" alt="" />
                <div class="dashboard-card__header-info">
                    <h4 class="dashboard-card__name">{{ user.fullName }}</h4>
                    <span class="dashboard-status dashboard-status--prospect">Prospect</span>
                </div>
            <router-link :to="{name: 'Client', params: { clientId: user.id}}" >
                <svg class="dashboard-card__arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </router-link>
            </header>
            <section class="dashboard-card__contact">
                <a :href="`mailto:${user.email}`" class="dashboard-card__contact-link">
                    <img :src="imgMail" alt="" />
                    {{ user.email }}
                </a>
                <a :href="`tel:${user.phone}`" class="dashboard-card__contact-link">
                    <img :src="imgPhone" alt="" />
                    {{ user.phone }}
                </a>
            </section>
            <footer class="dashboard-card__footer">
                <div v-if="user.colonne === 'col_pp'" class="dashboard-info-row">
                    <img :src="imgTime" alt="" />
                    Paysage : <span :class="statusPaysageClass" class="dashboard-badge">{{ statusPaysage }}</span>
                </div>
                <div v-if="user.colonne === 'col_conseil'" class="card-prospect__mission">
                    <div class="dashboard-info-row">
                        <img :src="imgDoc" alt="" />
                        Lettre de mission : <span :class="lettreMissionClass" class="dashboard-badge">{{ lettreMissionStatus }}</span>
                    </div>
                    <div class="dashboard-info-row">
                        <img :src="imgDoc" alt="" />
                        Rapport de mission <span :class="rapportMissionClass" class="dashboard-badge">{{ rapportMissionStatus }}</span>
                    </div>
                </div>
                <div v-if="user.colonne === 'col_inscription_partenaire'" class="dashboard-info-row">
                    <label class="card-prospect__toggle">
                        <span class="card-prospect__toggle-track" :class="{ 'card-prospect__toggle-track--active': user.partenaire_incription }">
                            <span class="card-prospect__toggle-thumb"></span>
                        </span>
                        <input
                            type="checkbox"
                            :checked="user.partenaire_incription"
                            @change="$emit('toggle-inscrit-partenaire', user.id, $event.target.checked)"
                            class="card-prospect__toggle-input"
                        />
                        <span class="card-prospect__toggle-label">Inscrit dans la base partenaire</span>
                    </label>
                </div>
                <div class="dashboard-info-row">
                    <img :src="imgCalendar" alt="" />
                    Créé il y a environ {{ daysSinceCreation }}<template v-if="creationDate"> (le {{ creationDate }})</template>
                </div>
            </footer>
	</article>
</template>

<style scoped>
.card-prospect {
	color: #979797;
    min-width: auto;
    overflow: hidden;
    @media (max-width: 1024px) {
        min-width: 300px;
    }
}

.card-prospect__mission {
	margin-bottom: 0.5rem;
}

.card-prospect__toggle {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
}

.card-prospect__toggle-input {
	position: absolute;
	opacity: 0;
	width: 0;
	height: 0;
	pointer-events: none;
}

.card-prospect__toggle-track {
	position: relative;
	display: inline-block;
	width: 36px;
	height: 20px;
	min-width: 36px;
	background: #d1d5db;
	border-radius: 20px;
	transition: background 0.2s ease;
}

.card-prospect__toggle-track--active {
	background: #AF9376;
}

.card-prospect__toggle-thumb {
	position: absolute;
	top: 2px;
	left: 2px;
	width: 16px;
	height: 16px;
	background: #fff;
	border-radius: 50%;
	transition: transform 0.2s ease;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.card-prospect__toggle-track--active .card-prospect__toggle-thumb {
	transform: translateX(16px);
}

.card-prospect__toggle-label {
	font-size: 0.85rem;
	user-select: none;
}
</style>


// WEBPACK FOOTER //
// CardProspect.vue?2f916329